import { usePausableTimeout } from '../../hooks/useBeats';
interface AutoAdvanceProps {
  /** Milliseconds of un-paused time to dwell on the current page. */
  after: number;
  onDone: () => void;
}

/**
 * Renders nothing. Keeps the teaser moving on its own so the whole story
 * lands inside the 30 seconds, while freezing whenever playback is paused
 * (including while the optional poll overlay is open).
 */
export function AutoAdvance({
  after,
  onDone
}: AutoAdvanceProps) {
  usePausableTimeout(onDone, after);
  return null;
}